import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft, User, Type, Palette, Badge, Plus } from 'lucide-react';

export const AnadirAEscena: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const idsParam = params.get('ids') || '';
  const ids = useMemo(() => idsParam.split(',').map(s => s.trim()).filter(Boolean), [idsParam]);

  const options: Array<{
    key: string;
    title: string;
    description: string;
    Icon: React.ComponentType<any>;
    colorBg: string;
    colorText: string;
  }> = [
    { key: 'modelo', title: 'Modelo', description: 'Agregá una persona o modelo a la escena.', Icon: User, colorBg: 'bg-blue-50', colorText: 'text-blue-600' },
    { key: 'texto', title: 'Texto', description: 'Insertá frases o slogans en la composición.', Icon: Type, colorBg: 'bg-purple-50', colorText: 'text-purple-600' },
    { key: 'colores', title: 'Colores', description: 'Definí paletas o acentos de color de la escena.', Icon: Palette, colorBg: 'bg-green-50', colorText: 'text-green-600' },
    { key: 'logo', title: 'Logo', description: 'Incluí tu logo para aparecer en la imagen.', Icon: Badge, colorBg: 'bg-orange-50', colorText: 'text-orange-600' },
  ];

  return (
    <div className="p-4 sm:p-8 sm:pb-0 max-w-4xl mx-auto min-h-[100dvh] md:min-h-screen bg-white sm:bg-transparent">
      <div className="sm:bg-white sm:rounded-2xl sm:shadow-sm p-0 sm:p-6">
        <div className="sm:hidden mt-2 mb-4 text-center">
          <h1 className="text-sm font-semibold text-gray-900">Añadir a la escena</h1>
          <p className="text-sm text-gray-600 mt-1">Añadí elementos para que formen parte de la imagen que se generará.</p>
        </div>

        <div className="hidden sm:flex items-start justify-between mb-6">
          <div>
            <h1 className="text-lg font-semibold text-gray-900">Añadir a la escena</h1>
            <p className="text-sm text-gray-600 mt-1">Añadí elementos para que formen parte de la imagen que se generará.</p>
          </div>
        </div>

        <div className="mt-4">
          <div className="w-full h-1 bg-transparent rounded-full" />
        </div>

        <div className="mt-6 space-y-3">
          {options.map(({ key, title, description, Icon, colorBg, colorText }) => (
            <button
              key={key}
              type="button"
              className="w-full text-left border border-gray-200 rounded-2xl p-4 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${colorBg}`}>
                    <Icon className={`w-5 h-5 ${colorText}`} />
                  </div>
                  <div className="flex-1">
                    <p className="text-gray-900 font-semibold text-sm">{title}</p>
                    <p className="text-gray-600 text-sm mt-1">{description}</p>
                  </div>
                </div>
                <div className="shrink-0 w-8 h-8 rounded-full bg-gray-50 text-gray-400 flex items-center justify-center">
                  <Plus className="w-4 h-4" />
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-6 hidden sm:flex items-center justify-between">
          <button
            type="button"
            onClick={() => {
              const qp = new URLSearchParams();
              if (ids.length > 0) qp.set('ids', ids.join(','));
              const query = qp.toString();
              navigate(query ? `/redes-sociales/crear-anuncio/prueba-nueva-interfaz?${query}` : '/redes-sociales/crear-anuncio/prueba-nueva-interfaz');
            }}
            className="inline-flex items-center justify-center w-10 h-10 text-gray-700 hover:bg-gray-100 rounded-md"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            type="button"
            onClick={() => {
              const qp = new URLSearchParams();
              if (ids.length > 0) qp.set('ids', ids.join(','));
              const query = qp.toString();
              navigate(query ? `/redes-sociales/crear-anuncio/prueba-nueva-interfaz?${query}` : '/redes-sociales/crear-anuncio/prueba-nueva-interfaz');
            }}
            className="inline-flex items-center justify-center gap-2 px-6 h-10 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 text-sm"
          >
            Listo
          </button>
        </div>
      </div>

      <div className="sm:hidden" style={{ height: 'calc(env(safe-area-inset-bottom, 0px) + 64px)' }} />

      <div className="sm:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-30">
        <div className="max-w-4xl mx-auto flex items-center gap-3">
          <button
            type="button"
            onClick={() => {
              const qp = new URLSearchParams();
              if (ids.length > 0) qp.set('ids', ids.join(','));
              const query = qp.toString();
              navigate(query ? `/redes-sociales/crear-anuncio/prueba-nueva-interfaz?${query}` : '/redes-sociales/crear-anuncio/prueba-nueva-interfaz');
            }}
            className="inline-flex items-center justify-center w-10 h-10 text-gray-700 hover:bg-gray-100 rounded-md"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <div className="flex-1 flex justify-end">
            <button
              type="button"
              onClick={() => {
                const qp = new URLSearchParams();
                if (ids.length > 0) qp.set('ids', ids.join(','));
                const query = qp.toString();
                navigate(query ? `/redes-sociales/crear-anuncio/prueba-nueva-interfaz?${query}` : '/redes-sociales/crear-anuncio/prueba-nueva-interfaz');
              }}
              className="inline-flex items-center justify-center gap-2 px-5 h-11 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 text-sm"
            >
              Listo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnadirAEscena;
